import { z } from 'zod';

export const FINDINGS_THEN_SORT_BY = [
  'createdAt',
  'updatedAt',
  'discoveryDate',
  'publishedAt',
  'isPublished',
  'title',
  'category',
  'signalId',
] as const;

export const FindingsThenSortBySchema = z.enum(FINDINGS_THEN_SORT_BY);

export type FindingsThenSortBy = z.infer<typeof FindingsThenSortBySchema>;

export const isFindingsThenSortBy = (
  sortBy: string | undefined,
): sortBy is FindingsThenSortBy =>
  FINDINGS_THEN_SORT_BY.some((thenSortBy) => thenSortBy === sortBy);

export const FindingsThenSortQueryShape = {
  thenSortBy: FindingsThenSortBySchema.optional().describe(
    'Secondary sort field applied within rows that tie on sortBy (for example inside a group)',
  ),
  thenSortOrder: z
    .enum(['asc', 'desc'])
    .optional()
    .describe('Sort order for thenSortBy'),
};
